import {environment} from "../../../environments/environment";
export const API_CONSTANTS = {
  USER_LOGIN : environment.apiEndPoint + "authenticateUser",
  GET_AUTHENTICATE_USER : environment.apiEndPoint + "getAuthenticateUser",
  CREATE_NEW_USER_URL_TEST : environment.apiEndPoint + "test123",
  DELETE_APPLICATION:  environment.apiEndPoint + "deleteApplication",
  GET_SUBMITTED_APPLICATION:  environment.apiEndPoint + "getSubmittedApplication",
  GET_APPLICATION_SUCCESS_INFO:  environment.apiEndPoint + "getLastPageContent",

  // Existing services
  CREATE_NEW_USER_URL : environment.apiEndPoint + "createUserService",
  // Used to load all application list
  GET_LIST_OF_APPLICATION:  environment.apiEndPoint + "getListofApplications",

  // used to open In-Complete Continue Application
  GET_APPLICATION_INFO:  environment.apiEndPoint + "getApplicationInfo",
  SAVE_APPLICATION_INFO:  environment.apiEndPoint + "setApplicationInfo",
  GET_APPLICATION_PDF:  environment.apiEndPoint + "getApplicationPDF",
  SUBMIT_APPLICATION_INFO:  environment.apiEndPoint + "paymentInfoUpdate",

  MLM_PROGRAM_START_DATE_FOR_ADMISSION_STATUS: environment.apiEndPoint + "getFeatureDates",
  GET_FEATURE_SEMESTER_DATE : environment.apiEndPoint + "getFeatureSemesterDate",
  GET_FEATURE_SEMESTER_DATE_SF : environment.apiEndPoint + "getFeatureSemesterDateFromSF",

  IN_ACTIVE_CURRENT_APPLICATION:  environment.apiEndPoint + "inactiveCurrentApplication",

  // Services for common values
  GET_ETHNICITY:  environment.apiEndPoint + "getListofEthnicities",
  GET_LIST_OF_INFO:  environment.apiEndPoint + "getListofInfoSources",
  GET_STATE:  environment.apiEndPoint + "getListofStates",
  GET_PROGRAM_LIST:  environment.apiEndPoint + "getProgramList",
  GET_TIU_SITE_LIST:  environment.apiEndPoint + "getTIUSiteList",
  GET_COUNTRY:  environment.apiEndPoint + "getListofCountries",
  VERIFY_EMAIL:  environment.apiEndPoint + "login/verifyAccount",
  SET_NEW_PASSWORD:  environment.apiEndPoint + "setNewPassword",
  FORGOT_PASSWORD_EMAIL:  environment.apiEndPoint + "forgotPasswordEmail",
  FORGOT_PASSWORD_ACCOUNT:  environment.apiEndPoint + "information/forgotPasswordAccount",

  GET_TLS_TABLE_OF_TABLE : environment.apiEndPoint + "getTLSTableOfTable",
  GET_INSTITUTION_LIST_FROM_SF:  environment.apiEndPoint + "getInstitutionListFromSF",

}



// WEBPACK FOOTER //
// ./src/app/common/constant/ApiConstants.ts